



export const AstricSign=()=>{
    return(
        <text style={{color:'red', fontSize:'14px', fontWeight:'bold'}}> * </text>
    )
}